<template>
    <div class="button-select"
         @mouseleave="hover = false"
         @mouseover="hover = true">
        <div @click="toggleList()" class="select">
            <span v-if="label[0] === 'Все'">{{localizeList.all}}</span>
            <span v-else>{{getLabel()}}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5"
                 width="10px" height="5px" :class="['drop-icon', {'rotate': showList}]" fill="var(--white-color)">
                <path d="M0 0L5 5L10 0H0Z"/>
            </svg>
        </div>
        <div class="drop-down-list" v-if="showList">
            <div v-for="(item, key) in list"
                 :key="key"
                 :class="['drop-down-item', {'active': item.label === label}]"
                 v-show="!item.label[1] || !item.label[1].includes('Infinity')"
                 @click="changeItem(item)">
                <span v-if="item.label[0] === 'Все'">{{localizeList.all}}</span>
                <span v-else>{{item.label[0]}}</span>
                <span v-if="item.label[0] !== 'Все'" class="blue-text ml-3">
                    {{localizeList[item.label[1]] +" "+ item.label[2]}}
                </span>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "button-select",
        data() {
            return {
                showList: false,
                label: [],
                hover: false,
                select: null,
                list: []
            }
        },
        props: {
            items: {
                type: Array,
                required: true
            },
            value: {
                type: [String, Number],
            },
        },
        mounted() {
            this.list = this.items.slice();
            if (this.items.filter(x => x.value === this.value).length) {
                this.label = this.items.filter(x => x.value === this.value).label || this.items[0].label
            }
            this.select = this.value;
            window.addEventListener("click", this.outside)
        },
        methods: {
            getLabel() {
                return this.label[0] +", "+ this.localizeList[this.label[1]] +" "+ this.label[2]
            },
            outside() {
                if (!this.hover) {
                    this.hideList();
                }
            },
            toggleList() {
                this.showList = !this.showList
            },
            changeItem(item) {
                this.label = item.label.slice();
                this.select = item.value;
                this.$emit("change", item.value)
                this.hideList();
            },
            hideList() {
                this.showList = false
            }
        },
        watch: {
            items: {
                deep: true,
                handler(val) {
                    this.list = val.slice();
                    let index = this.list.map(x => x.value).indexOf(this.select);
                    if (index !== -1) this.label = this.list[index].label
                }
            },
            value(val) {
                this.select = val;
            },
            select(val) {
                let index = this.list.map(x => x.value).indexOf(val)
                if (index !== -1) this.label = this.list[index].label
                this.$emit("input", val)
            }
        },
        beforeDestroy() {
            window.removeEventListener("click", this.outside);
        }
    }
</script>

<style scoped>
    .button-select {
        position: relative;
        width: 100%;
    }

    .button-select .select {
        position: relative;
        width: 100%;
        border: none;
        outline: none;
        padding: 9px 40px 9px 12px;
        background-color: var(--primary-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: var(--white-color);
        cursor: pointer;
    }

    .button-select .select .drop-icon{
        position: absolute;
        top: calc(50% - 2px);
        right: 11px;
        transition: all .2s;
    }

    .button-select .select .drop-icon.rotate{
        transform: rotate(180deg)
    }

    .button-select .drop-down-list {
        min-width: 100%;
        max-height: 136px;
        overflow: auto;
        position: absolute;
        top: 100%;
        left: 0;
        border-radius: 4px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        padding: 4px 0;
        background-color: var(--white-color);
        z-index: 10;
    }

    .button-select .drop-down-list .drop-down-item {
        display: flex;
        justify-content: space-between;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        padding: 6px 12px;
        transition: all .2s;
        cursor: pointer;
    }

    .button-select .drop-down-list .drop-down-item .blue-text {
        color: var(--primary-color)
    }

    .button-select .drop-down-list .drop-down-item:hover,
    .button-select .drop-down-list .drop-down-item.active {
        background-color: var(--primary-2-color);
    }
</style>
